function svgcenter () {
  var windowheight = $(window).height()
  var windowwidth = $(window).width()
  var coversheight = $('#covers').height()
  var currenttrackwidth = $('#center').width()
  var currenttrackheight = $('#center').height()
  var tracklistwidth = $('.tracklist').height()

   // $('#covers').css('top', (windowheight - coversheight) / 2 + 'px');
  $('.tracklist svg').attr('height', (windowheight - 150))
  $('.tracklist_button svg').attr('height', (windowheight - 150))
  $('#center').css('top', (windowheight - currenttrackheight) / 2 + 'px')
  $('#center').css('left', (windowwidth - currenttrackwidth) / 2 + 'px')

  var svgWidth = svgCalculateSize(document.getElementsByTagName('svg')[0])

// console.log(svgWidth)
  $('.tracklist').css('left', (windowwidth - svgWidth.width) / 2)
  $('.tracklist_button').css('left', (windowwidth - svgWidth.width) / 2)
  $('#title').css('left', (windowwidth - 300) / 2)

  $('.tracklist').css('top', (windowheight - svgWidth.height) / 2)
  $('.tracklist_button').css('top', (windowheight - svgWidth.height) / 2)
};

export default svgcenter

var heightComponents = ['height', 'paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth'],
  widthComponents = ['width', 'paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth']

var svgCalculateSize = function (el) {
  var gCS = window.getComputedStyle(el), // using gCS because IE8- has no support for svg anyway
    bounds = {
      width: 0,
      height: 0
    }

  heightComponents.forEach(function (css) {
    bounds.height += parseFloat(gCS[css])
  })
  widthComponents.forEach(function (css) {
    bounds.width += parseFloat(gCS[css])
  })
  return bounds
}

window.addEventListener('resize', svgcenter, false)
svgcenter()
